/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * NXT48
 * API documentation generated from Zod schemas
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnonymousGetProfile200,
  AnonymousGetProfile400,
  AnonymousIdentify200,
  AnonymousIdentify400,
  AnonymousIdentifyBody,
  AnonymousUpdateProfile200,
  AnonymousUpdateProfile400,
  AnonymousUpdateProfileBody
} from '../nxt48.schemas';

import { customInstance } from '../../orval-fetcher';




/**
 * Identify or create an anonymous profile from multiple sources
 * @summary Identify Anonymous User
 */
export const anonymousIdentify = (
    anonymousIdentifyBody: AnonymousIdentifyBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AnonymousIdentify200>(
      {url: `/anonymous/identify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: anonymousIdentifyBody, signal
    },
      );
    }
  


export const getAnonymousIdentifyMutationOptions = <TError = AnonymousIdentify400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof anonymousIdentify>>, TError,{data: AnonymousIdentifyBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof anonymousIdentify>>, TError,{data: AnonymousIdentifyBody}, TContext> => {

const mutationKey = ['anonymousIdentify'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof anonymousIdentify>>, {data: AnonymousIdentifyBody}> = (props) => {
          const {data} = props ?? {};

          return  anonymousIdentify(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AnonymousIdentifyMutationResult = NonNullable<Awaited<ReturnType<typeof anonymousIdentify>>>
    export type AnonymousIdentifyMutationBody = AnonymousIdentifyBody
    export type AnonymousIdentifyMutationError = AnonymousIdentify400

    /**
 * @summary Identify Anonymous User
 */
export const useAnonymousIdentify = <TError = AnonymousIdentify400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof anonymousIdentify>>, TError,{data: AnonymousIdentifyBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof anonymousIdentify>>,
        TError,
        {data: AnonymousIdentifyBody},
        TContext
      > => {

      const mutationOptions = getAnonymousIdentifyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Update anonymous profile data (email, phone, push token)
 * @summary Update Anonymous Profile
 */
export const anonymousUpdateProfile = (
    anonymousUpdateProfileBody: AnonymousUpdateProfileBody,
 ) => {
      
      
      return customInstance<AnonymousUpdateProfile200>(
      {url: `/anonymous/profile`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: anonymousUpdateProfileBody
    },
      );
    }
  


export const getAnonymousUpdateProfileMutationOptions = <TError = AnonymousUpdateProfile400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof anonymousUpdateProfile>>, TError,{data: AnonymousUpdateProfileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof anonymousUpdateProfile>>, TError,{data: AnonymousUpdateProfileBody}, TContext> => {

const mutationKey = ['anonymousUpdateProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof anonymousUpdateProfile>>, {data: AnonymousUpdateProfileBody}> = (props) => {
          const {data} = props ?? {};

          return  anonymousUpdateProfile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AnonymousUpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof anonymousUpdateProfile>>>
    export type AnonymousUpdateProfileMutationBody = AnonymousUpdateProfileBody
    export type AnonymousUpdateProfileMutationError = AnonymousUpdateProfile400

    /**
 * @summary Update Anonymous Profile
 */
export const useAnonymousUpdateProfile = <TError = AnonymousUpdateProfile400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof anonymousUpdateProfile>>, TError,{data: AnonymousUpdateProfileBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof anonymousUpdateProfile>>,
        TError,
        {data: AnonymousUpdateProfileBody},
        TContext
      > => {

      const mutationOptions = getAnonymousUpdateProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get anonymous profile by clientId
 * @summary Get Anonymous Profile
 */
export const anonymousGetProfile = (
    clientId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AnonymousGetProfile200>(
      {url: `/anonymous/profile/${clientId}`, method: 'GET', signal
    },
      );
    }
  



export const getAnonymousGetProfileQueryKey = (clientId?: string,) => {
    return [
    `/anonymous/profile/${clientId}`
    ] as const;
    }

    
export const getAnonymousGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof anonymousGetProfile>>, TError = AnonymousGetProfile400>(clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof anonymousGetProfile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAnonymousGetProfileQueryKey(clientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof anonymousGetProfile>>> = ({ signal }) => anonymousGetProfile(clientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof anonymousGetProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AnonymousGetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof anonymousGetProfile>>>
export type AnonymousGetProfileQueryError = AnonymousGetProfile400


export function useAnonymousGetProfile<TData = Awaited<ReturnType<typeof anonymousGetProfile>>, TError = AnonymousGetProfile400>(
 clientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof anonymousGetProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof anonymousGetProfile>>,
          TError,
          Awaited<ReturnType<typeof anonymousGetProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAnonymousGetProfile<TData = Awaited<ReturnType<typeof anonymousGetProfile>>, TError = AnonymousGetProfile400>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof anonymousGetProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof anonymousGetProfile>>,
          TError,
          Awaited<ReturnType<typeof anonymousGetProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAnonymousGetProfile<TData = Awaited<ReturnType<typeof anonymousGetProfile>>, TError = AnonymousGetProfile400>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof anonymousGetProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Anonymous Profile
 */

export function useAnonymousGetProfile<TData = Awaited<ReturnType<typeof anonymousGetProfile>>, TError = AnonymousGetProfile400>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof anonymousGetProfile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAnonymousGetProfileQueryOptions(clientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




